import { loadLocale } from '../../i18n/i18n'

const allowedLocales = ['en', 'de', 'fr']

export function getLocaleFromCookie(): string | null {
  if (typeof document === 'undefined') return null

  const match = document.cookie.match(/locale=([^;]+)/)
  return match ? match[1] : null
}

export function setLocaleCookie(locale: string): void {
  if (typeof document === 'undefined') return

  document.cookie = `locale=${locale}; path=/; max-age=31536000` // 1 year
}

export function detectClientLocale(): string {
  // Priority: Cookie > Browser language > Default
  const cookieLocale = getLocaleFromCookie()
  if (cookieLocale && allowedLocales.includes(cookieLocale)) {
    return cookieLocale
  }

  // Use browser language if available
  if (typeof navigator !== 'undefined' && navigator.language) {
    const browserLang = navigator.language.split('-')[0]
    if (allowedLocales.includes(browserLang)) {
      return browserLang
    }
  }

  return 'de' // Default fallback
}

export function initializeClientI18n(): string {
  const locale = detectClientLocale()

  // Check if locale cookie is set, if not set it
  const cookieLocale = getLocaleFromCookie()
  if (!cookieLocale) {
    setLocaleCookie(locale)
  }

  loadLocale(locale)
  return locale
}

export function changeLocale(locale: string): void {
  if (!allowedLocales.includes(locale)) {
    console.warn(`Unsupported locale: ${locale}`)
    return
  }

  setLocaleCookie(locale)
  loadLocale(locale)

  // Reload the page to apply the new locale
  window.location.reload()
}
